$(document).on 'turbo:load', ->
  bindVideos = (idx, ctrl) ->
    video = document.getElementById $(ctrl).data('video-ctrl')
    return if video.length < 1

    video.addEventListener 'play', ( =>
      $(ctrl).find(".js-play").hide()
      $(ctrl).find(".js-pause").show()
    ), false

    video.addEventListener 'pause', ( =>
      $(ctrl).find(".js-play").show()
      $(ctrl).find(".js-pause").hide()
    ), false

    $(ctrl).on 'click', ( =>
      if video.paused
        video.play()
      else
        video.pause()
    )

  toggleAllVideos = (e) ->
    action = $(e.currentTarget).data('all-videos-ctrl')
    videos = document.querySelectorAll('video')
    $toggle = $(e.currentTarget)
    pause = action == "pause"

    toggleAction = if pause then 'play' else 'pause'
    $toggle
      .data('all-videos-ctrl', toggleAction)
      .attr('data-all-videos-ctrl', toggleAction)

    show = if pause then 'play' else 'pause'
    hide = if pause then 'pause' else 'play'
    $toggle.find("[data-text='#{show}']").show()
    $toggle.find("[data-text='#{hide}']").hide()

    videos.forEach (video) =>
      if action == "pause"
        video.autoplay = false
        video.pause()
      else
        video.autoplay = true
        video.play()

  bindControls = () ->
    $('[data-video-ctrl]').each bindVideos
    $(document).on 'click', '[data-all-videos-ctrl]', toggleAllVideos
    return

  $(document).on 'ready', bindControls